// Switching from classic to the new dashboard experience (v2), which is in
// beta. Super admins get a button in the sidebar and at the bottom of Settings ›
// General; partners can turn it on from the Partner page in the partner portal.
// Either way it asks first, then switches this browser (utils/dashboard-version).
import React from 'react';
import PropTypes from 'prop-types';

import Button from 'components/button';
import { switchDashboard } from 'utils/dashboard-version';

import './dashboard-switch.scss';

/** Shows the beta warning, then switches this browser to the new experience. */
export function confirmNewExperience(openModal) {
  openModal('Confirm', {
    title: 'Try the new experience',
    message: (
      <p>
        The new dashboard experience is in beta. It doesn’t support everything
        the classic dashboard does yet, so use it at your own risk.
        <br />
        <br />
        You can switch back to the classic dashboard at any time from the
        sidebar or the account menu.
      </p>
    ),
    action: 'Switch to the new experience',
    width: 440,
    onConfirm: () => switchDashboard('v2'),
  });
}

/**
 * Wraps the new experience. When it can't load (its code failed to download,
 * say during a deploy) or fails to render, this says so and offers the way
 * back to classic, instead of a blank page on every reload
 */
export class NewExperienceBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  state = { failed: false };

  componentDidCatch(error) {
    console.error('The new dashboard failed to load', error);
  }

  render() {
    if (!this.state.failed) {
      return this.props.children;
    }

    return (
      <div className="dashboard-switch-failed">
        <h3>The new dashboard couldn’t load</h3>
        <p className="muted">
          Switch back to the classic dashboard to keep working. You can try the
          new experience again later.
        </p>
        <Button onClick={() => switchDashboard('classic')}>
          Switch back to classic
        </Button>
      </div>
    );
  }
}
